import { IonLoading } from "@ionic/react";
import React from "react";
import "./Loading.scss";

const Loading = () => {
  return <IonLoading isOpen={true} message="Loading" cssClass="authLoading" />;
};

export default Loading;
